import {
  Hero,
  ValueProposition,
  HowItWorks,
  Comparison,
  FooterCTA,
  Footer,
  Navigation,
} from '../components'

export const Home = () => {
  return (
    <div className="min-h-screen bg-white font-sans overflow-x-hidden">
      <Navigation />
      <main className="relative">
        <Hero />
        <ValueProposition />
        <HowItWorks />
        <Comparison />
        <FooterCTA />
      </main>
      <Footer />
    </div>
  )
}
